export const ACCESS_REQUEST = '@user/ACCESS_REQUEST';
export const ACCESS_REQUEST_SUCCESS = '@user/ACCESS_REQUEST_SUCCESS';
export const ACCESS_REQUEST_FAIL = '@user/ACCESS_REQUEST_FAIL';
